export default `
    mutation ($service: String!, $sortKey: String!, $userKey: String){
        clientConnectionDelete(service: $service, sortKey: $sortKey, userKey: $userKey){
            accountId
        }
    }
`;
